import { FadeUp } from "./anim";
import { IMAGES } from "./site-data";

const CHAPTERS = [
  {
    n: "01",
    tag: "Grow",
    title: "Grow something good, below.",
    body: "Herbs, tomatoes, greens, flowers or a young olive tree — the deep raised bed gives roots room to thrive. The canopy above shelters delicate plants from harsh midday sun so your garden stays lush all season.",
    img: IMAGES.herbs,
    alt: "Fresh herbs growing",
  },
  {
    n: "02",
    tag: "Solar",
    title: "Solar without sacrificing your roof.",
    body: "The Solar Garden is a freestanding outdoor feature — so you can add solar without covering your roof in panels. Its integrated panel captures sunlight throughout the day, right where it looks like it belongs.",
    img: IMAGES.solar,
    alt: "Solar panel detail",
  },
  {
    n: "03",
    tag: "Save",
    title: "Real production. Real bill offset.",
    body: "A built-in microinverter converts solar energy into usable AC power. When installed and connected per applicable utility requirements, that production can offset a portion of the electricity your home would otherwise buy.",
    img: IMAGES.evening,
    alt: "Patio with warm evening lighting",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      className="relative bg-sg-bg py-24 sm:py-32"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <FadeUp className="max-w-2xl mb-20">
          <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
            More than a planter
          </span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-sg-fg">
            One space. Two harvests.
          </h2>
        </FadeUp>

        <div className="flex flex-col gap-24 sm:gap-40">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.n}
              className={`grid gap-8 lg:gap-16 lg:grid-cols-12 items-center ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <div className="lg:col-span-5 lg:[direction:ltr]">
                <FadeUp>
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-6xl sm:text-7xl text-sg-primary/30 leading-none">
                      {c.n}
                    </span>
                    <span className="text-xs uppercase tracking-[0.3em] text-sg-primary">
                      {c.tag}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-3xl sm:text-4xl tracking-tight text-sg-fg leading-tight">
                    {c.title}
                  </h3>
                  <p className="mt-5 text-base text-sg-muted font-light leading-relaxed max-w-md">
                    {c.body}
                  </p>
                </FadeUp>
              </div>
              <div className="lg:col-span-7 lg:[direction:ltr]">
                <FadeUp delay={0.1} y={60}>
                  <div className="relative overflow-hidden rounded-2xl border border-white/5 aspect-[4/3] group">
                    <img
                      src={c.img}
                      alt={c.alt}
                      className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-2xl" />
                  </div>
                </FadeUp>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
